import type { IPermitTypeField } from '~/client/graph/types.generated'
import { isTemplateFilter } from '~/client/src/shared/constants/FilterPropertyMaps/ResourceFilterPropMap'
import type LocationBase from '~/client/src/shared/models/LocationObjects/LocationBase'
import type PermitField from '~/client/src/shared/models/PermitField'
import { isLocationResourceType } from '~/client/src/shared/resources/domain/locationKind'

import { evaluateFiltersWithLbsContext } from './filterEvaluationHelpers'

// The form allow-list only limits which forms creation offers, as for every resource type.
export function isLocationOfferedForField(
  field: Pick<IPermitTypeField, 'filterOptions' | 'isLBSLogicEnabled'>,
  location: LocationBase,
  lbsRestrictedIds: Set<string>,
  workflowFieldsMap?: Record<string, PermitField>,
): boolean {
  return (
    isLocationResourceType(location.type) &&
    location.isBookable &&
    evaluateFiltersWithLbsContext(
      (field.filterOptions ?? []).filter(filter => !isTemplateFilter(filter)),
      location,
      !!field.isLBSLogicEnabled,
      lbsRestrictedIds,
      workflowFieldsMap,
    )
  )
}
